<template>
	<svg version="1.1" width="30px" height="30px" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512"
		enable-background="new 0 0 512 512" xml:space="preserve">
		<polygon points="0,0 0,512 512,256 " />
	</svg>
</template>